import Page from 'modules/WgsResults'

export default Page

